import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/admin/leave/`;

const getAdminLeaves = async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    return await axios.get(API_URL + (queryString ? `?${queryString}` : ''));
};

const getAdminLeave = async (id) => {
    return await axios.get(API_URL + id);
};

const addAdminLeave = async (leaveData) => {
    return await axios.post(API_URL, leaveData);
};

const editAdminLeave = async (id, leaveData) => {
    return await axios.put(API_URL + id, leaveData);
};

const deleteAdminLeave = async (id) => {
    return await axios.delete(API_URL + id);
};

const AdminLeaveService = {
    getAdminLeaves,
    getAdminLeave,
    addAdminLeave,
    editAdminLeave,
    deleteAdminLeave
};

export default AdminLeaveService;

